import FormPedido from '../componentes/FormPedido.vue'
import ListaPedido from '../componentes/ListaPedido.vue'
import ListaNotas from '../componentes/ListaNotas.vue'
import ListaAbonoEntrante from '../componentes/ListaAbonoEntrante.vue'
import FormFacturaEntrante from '../componentes/FormFacturaEntrante.vue'
import ListaFacturaEntrante from '../componentes/ListaFacturaEntrante.vue'
import ListadoIvaEntrantes from '../componentes/ListadoIvaEntrantes.vue'

const meta_nota = {
    Auth: true,
    nota: 1,
    title: "Crear/Editar Nota",
    ///req_admin: true
};
const meta_factura = {
    Auth: true,
    nota: 0,
    title: "Crear/Editar Factura",
    ///req_admin: true
};

const routes = [
    ...route('/guardar-pedido-proveedor', FormPedido, {
        Auth: true,
        ///req_admin: true
     }),
     ...route('/lista-pedido-proveedor', ListaPedido, {
       Auth: true,
       //req_admin: true
    }),
    ...route('/lista-notas-proveedores', ListaNotas, {
        Auth: true,
        //req_admin: true
     }),
     ...route('/lista-abonos-entrantes', ListaAbonoEntrante, {
        Auth: true,
        //req_admin: true
     }),
    ...route("/guardar-factura-entrante", FormFacturaEntrante, meta_factura),

    ...route("/guardar-nota-proveedor", FormFacturaEntrante, meta_nota),
    
    ...route("/lista-facturas-entrante", ListaFacturaEntrante, {
        Auth: true,
        //req_admin: true
    }),
    ...route("/listado-iva-entrantes", ListadoIvaEntrantes, {
        Auth: true,
    }),

]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes